import React, { useCallback } from 'react';
import c from 'classnames';

import { useTranslation } from '@lyearn/i18n';
import { BaseButton, FileInput, Typography, useSnackbar } from '@lyearn/ui';

import { useHandleInputChange } from '../../hooks/useHandleInputChange';
import { buttonIcon, buttonInput, uploadButton } from './style';
import { UploadButtonProps } from './types';

function UploadButton(props: UploadButtonProps) {
  const { placeHolder, PlaceholderIcon, type, id } = props;
  const { t } = useTranslation();
  const { handleInputChange } = useHandleInputChange(id);
  const { showErrorSnackbar } = useSnackbar();

  const onFileSelectErrorHandler = useCallback(() => {
    showErrorSnackbar({
      message: t('Common:FileTypeNotAllowedToBeUploaded', { accept: type }),
    });
  }, [showErrorSnackbar, type, t]);

  return (
    <div className="mt-16">
      <FileInput
        accept={type}
        className={buttonInput}
        id={id + 'input'}
        onChange={handleInputChange}
        onFileSelectError={onFileSelectErrorHandler}
      />
      <label htmlFor={id + 'input'}>
        {/* @ts-ignore */}
        <BaseButton fullWidth className={c('justify-start', uploadButton)} component="span">
          <PlaceholderIcon className={buttonIcon} width={28} />
          <Typography className="text-text-placeholder ps-12" variant="body-short-02">
            {placeHolder}
          </Typography>
        </BaseButton>
      </label>
    </div>
  );
}

export default UploadButton;
